import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '../components/Login.vue';
import NotFound from '../components/404.vue';
import Emailtoreset from '../components/Emailtoreset.vue';
import PasswordReset from '../components/Passwordreset.vue';
import Maindash from  '../components/Dashboard/Maindash.vue';
import DashPanel from  '../components/Dashboard/Appages/DashPanel.vue';
import CreateBoardAgent from  '../components/Dashboard/Appages/Agent/CreateBoardAgent.vue';
import CreateAgent from  '../components/Dashboard/Appages/Agent/CreateAgent.vue';
import ListAgents from  '../components/Dashboard/Appages/Agent/ListAgents.vue';
import CreateSubAdmin from  '../components/Dashboard/Appages/Admin/CreateSubAdmin.vue';
import ListAdmins from  '../components/Dashboard/Appages/Admin/ListAdmins.vue';
import CreateItem from  '../components/Dashboard/Appages/Items/CreateItem.vue';
import CreateBeneficiary from  '../components/Dashboard/Appages/Beneficiary/CreateBeneficiary.vue';
import ListBeneficiary from  '../components/Dashboard/Appages/Beneficiary/ListBeneficiary.vue';
import ViewProfile from  '../components/Dashboard/Appages/Beneficiary/ViewProfile.vue';
import AssignMenu from  '../components/Dashboard/Appages/Menu/AssignMenu.vue';
import ManageMenu from  '../components/Dashboard/Appages/Menu/ManageMenu.vue';
import EnrollState from  '../components/Dashboard/Appages/States_enrolled/EnrollState.vue';
import ListStateEnrolled from  '../components/Dashboard/Appages/States_enrolled/ListStateEnrolled.vue';

Vue.use(VueRouter);

const router = new VueRouter({
  routes: [
    {
      path: '/',
      name: 'start',
      component: Login
    },{
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        guest: true
      }
    },{
      path: '/reset_password',
      name: 'reset_password',
      component: Emailtoreset,
      meta: {
        guest: true
      }
    },{
      path: '/setpassword/:id',
      name: 'setpassword',
      component: PasswordReset,
      meta: {
        guest: true
      }
    },{
      path: '/dashboard',
      children:[
        {
          path: '/',
          name: 'Dashboard',
          component: DashPanel,
          meta: {
            requiresAuth: true
          }
        },{
          path: '/createboardagent',
          component: CreateBoardAgent,
          // meta: {
          //   requiresAuth: true
          // }
        },{
          path: '/createagent',
          component: CreateAgent,
          meta: {
            requiresAuth: true
          }
        },{
          path: '/createsubadmin',
          component: CreateSubAdmin,
          meta: {
            requiresAuth: true
          }
        },{
          path: '/listadmins',
          component: ListAdmins,
          meta: {
            requiresAuth: true
          }
        },{
          path: '/listagents',
          component: ListAgents,
          meta: {
            requiresAuth: true
          }
        },{
          path: '/createitem',
          component: CreateItem,
          meta: {
            requiresAuth: true
          }
        },{
          path: '/createbeneficiary',
          component: CreateBeneficiary,
          meta: {
            requiresAuth: true
          }
        },{
          path: '/listbeneficiary',
          component: ListBeneficiary,
          meta: {
            requiresAuth: true
          }
        },{
          path: '/viewprofile/:id',
          component: ViewProfile,
          name: "viewprofile",
          meta: {
            requiresAuth: true
          }
        },{
          path: '/managemenu',
          component: ManageMenu,
          name: "ManageMenu",
          meta: {
            requiresAuth: true
          }
        },{
          path: '/enrollstate',
          component: EnrollState,
          name: "EnrollState",
          // meta: {
          //   requiresAuth: true
          // }
        },{
          path: '/liststate',
          component: ListStateEnrolled,
          name: "ListStateEnrolled",
          meta: {
            requiresAuth: true
          }
        },{
          path: '/assignmenu',
          component: AssignMenu,
          name: "AssignMenu",
          meta: {
            requiresAuth: true
          }
        },

      ],
      component: Maindash,
      meta: {
        guest: true
      }
    },
    { path: '*', component: NotFound }
  ]
})

router.beforeEach((to, from, next) => {
  if(to.meta.requiresAuth) {
    if (localStorage.getItem('XATHWAT') == null || localStorage.getItem('GWEND127') == null) {
      next({
        path: '/login',
        params: { nextUrl: to.fullPath }
      })
    } 

    // check if adminType is super or normal admin
    const encodedString = localStorage.getItem('GWEND127')
    const adminDetails = JSON.parse(atob(encodedString));
    if (adminDetails.adminType == 1) {
      next()
      return ;
    }
    
    // get admin's menu
    // let adminMenu = localStorage.getItem('GWENDMENU')
    // console.log(adminMenu);
    // adminMenu = JSON.parse(atob(adminMenu));
    
    // dashboard is open for all
    if (to.path.includes('/dashboard')) {
      next();
      return ;
    }

    // check if the path is assigned to the admin's menu
    // let menuExists = false;
    // for (let i = 0; i < adminMenu.length; i++) {
    //   const menu = adminMenu[i];
    //   if (menuExists) {
    //     break;
    //   }

    //   if (menu.hasSubMenu == 0 && menu.menuUrl == to.path) {
    //     menuExists = true;
    //     break;
    //   }

    //   if (menu.hasSubMenu == 1) {
    //     for (let j = 0; j < menu.subMenus.length; j++) {
    //       const submenu = menu.subMenus[j];
    //       if (submenu.subMenuUrl == to.path) {
    //         menuExists = true;
    //         break;
    //       }
    //     }
    //   } 
    // }

    // if (menuExists) {
    //   next();
    //   return ;
    // }else{
    //   next({
    //     path: from.path
    //   })
    //   return ;
    // }
    
  } else {
    next();
    return ;
  }
})

export default router